// قائمة إذاعات العالم الإسلامي والدولي المجهزة مع روابط البث وصور عالية الدقة
export const DEFAULT_RADIOS = [
  // ================= 1. إذاعات المملكة العربية السعودية والحرمين الشريفين 🇸🇦 =================
  {
    id: 'cairo-quran',
    name: 'إذاعة القرآن الكريم من القاهرة',
    reciter: 'كبار قراء مصر والعالم الإسلامي',
    country: 'مصر',
    countryCode: 'EG',
    countryFlag: '🇪🇬',
    url: 'https://stream.radiojar.com/8s5u5tpdtwzuv',
    category: 'إذاعات عامة',
    description: 'البث المباشر لإذاعة القرآن الكريم العريقة من القاهرة مع تلاوات خاشعة وبرامج دينية وتفسير.'
  },
  {
    id: 'saudi-quran',
    name: 'إذاعة القرآن الكريم من السعودية',
    reciter: 'الرياض • بث الحرمين الشريفين',
    country: 'السعودية',
    countryCode: 'SA',
    countryFlag: '🇸🇦',
    url: 'https://stream.radiojar.com/4wqre23fytzuv',
    backupUrl: 'https://backup.qurango.net/radio/radio_saudi',
    category: 'الحرمين الشريفين',
    description: 'البث الرسمي لإذاعة القرآن الكريم من المملكة العربية السعودية وصلوات وتلاوات الحرمين.'
  },
  {
    id: 'makkah-live',
    name: 'إذاعة الحرم المكي الشريف',
    reciter: 'أئمة ومؤذنو المسجد الحرام',
    country: 'السعودية',
    countryCode: 'SA',
    countryFlag: '🕋',
    url: 'https://backup.qurango.net/radio/radio_makkah',
    backupUrl: 'https://qurango.net/radio/makkah',
    category: 'الحرمين الشريفين',
    description: 'تلاوات مباشرة وصلوات وأذان من بيت الله الحرام بمكة المكرمة.'
  },
  {
    id: 'madinah-live',
    name: 'إذاعة الحرم المدني الشريف',
    reciter: 'أئمة ومؤذنو المسجد النبوي',
    country: 'السعودية',
    countryCode: 'SA',
    countryFlag: '🕌',
    url: 'https://backup.qurango.net/radio/radio_tarawih_madinah',
    backupUrl: 'https://qurango.net/radio/tarawih_madinah',
    category: 'الحرمين الشريفين',
    description: 'تلاوات وأدعية وأذان من المسجد النبوي الشريف بالمدينة المنورة.'
  },
  {
    id: 'neda-alislam',
    name: 'إذاعة نداء الإسلام من مكة المكرمة',
    reciter: 'برامج دعوية وتلاوات مباركة',
    country: 'السعودية',
    countryCode: 'SA',
    countryFlag: '🇸🇦',
    url: 'https://backup.qurango.net/radio/radio_neda_alislam',
    backupUrl: 'https://qurango.net/radio/neda_alislam',
    category: 'إذاعات عامة',
    description: 'صوت إسلامي رائد يبث من جوار الكعبة المشرفة بمكة المكرمة إلى كافة أصقاع المعمورة.'
  },
  {
    id: 'hajj-radio',
    name: 'إذاعة مناسك الحج والعمرة',
    reciter: 'إرشادات وفتاوى وتلاوات الحرمين',
    country: 'السعودية',
    countryCode: 'SA',
    countryFlag: '🇸🇦',
    url: 'https://backup.qurango.net/radio/radio_hajj',
    backupUrl: 'https://qurango.net/radio/hajj',
    category: 'الحرمين الشريفين',
    description: 'إذاعة متخصصة في توجيه ضيوف الرحمن وأحكام الحج والعمرة والتلبية والتكبير.'
  },

  // ================= 2. إذاعات الخليج العربي 🇦🇪 🇰🇼 🇶🇦 🇴🇲 🇧🇭 =================
  {
    id: 'sharjah-quran',
    name: 'إذاعة القرآن الكريم من الشارقة',
    reciter: 'هيئة الشارقة للإذاعة والتلفزيون',
    country: 'الإمارات',
    countryCode: 'AE',
    countryFlag: '🇦🇪',
    url: 'https://l3.itworkscdn.net/smcquranlive/quranradiolive/icecast.audio',
    category: 'الخليج العربي',
    description: 'إذاعة القرآن الكريم المتميزة من إمارة الشارقة بدولة الإمارات العربية المتحدة.'
  },
  {
    id: 'abu-dhabi-quran',
    name: 'إذاعة القرآن الكريم من أبوظبي',
    reciter: 'شبكة أبوظبي للإعلام',
    country: 'الإمارات',
    countryCode: 'AE',
    countryFlag: '🇦🇪',
    url: 'https://backup.qurango.net/radio/radio_abu_dhabi',
    backupUrl: 'https://qurango.net/radio/abu_dhabi',
    category: 'الخليج العربي',
    description: 'بث قرآني عذب على مدار 24 ساعة من عاصمة الإمارات أبوظبي.'
  },
  {
    id: 'kuwait-quran',
    name: 'إذاعة القرآن الكريم من دولة الكويت',
    reciter: 'وزارة الإعلام الكويتية',
    country: 'الكويت',
    countryCode: 'KW',
    countryFlag: '🇰🇼',
    url: 'https://radio.mp3islam.com/listen/quran_radio/radio.mp3',
    category: 'الخليج العربي',
    description: 'إذاعة القرآن الكريم الرسمية من دولة الكويت مع برامج الفقه والتفسير والتلاوات.'
  },
  {
    id: 'qatar-quran',
    name: 'إذاعة القرآن الكريم من الدوحة - قطر',
    reciter: 'المؤسسة القطرية للإعلام',
    country: 'قطر',
    countryCode: 'QA',
    countryFlag: '🇶🇦',
    url: 'https://backup.qurango.net/radio/radio_qatar',
    backupUrl: 'https://qurango.net/radio/qatar',
    category: 'الخليج العربي',
    description: 'إذاعة القرآن الكريم من الدوحة قطر مع كوكبة من العلماء والقراء المتميزين.'
  },
  {
    id: 'oman-quran',
    name: 'إذاعة القرآن الكريم من سلطنة عُمان',
    reciter: 'إذاعة سلطنة عُمان - مسقط',
    country: 'عُمان',
    countryCode: 'OM',
    countryFlag: '🇴🇲',
    url: 'https://partwota.cdn.mgmlcdn.com/quranrdoorg/quranrdo.stream_aac/chunklist.m3u8',
    category: 'الخليج العربي',
    description: 'البث القرآني والبرامج الدينية من سلطنة عمان.'
  },
  {
    id: 'bahrain-quran',
    name: 'إذاعة القرآن الكريم من مملكة البحرين',
    reciter: 'هيئة الإذاعة والتلفزيون - المنامة',
    country: 'البحرين',
    countryCode: 'BH',
    countryFlag: '🇧🇭',
    url: 'https://5c7b683162943.streamlock.net/live/ngrp:radio-106-1_all/playlist.m3u8',
    category: 'الخليج العربي',
    description: 'تلاوات ندية وبرامج حوارية إسلامية من مملكة البحرين.'
  },

  // ================= 3. إذاعات شمال أفريقيا والمغرب العربي 🇲🇦 🇩🇿 🇹🇳 =================
  {
    id: 'morocco-mohammed6',
    name: 'إذاعة محمد السادس للقرآن الكريم - المغرب',
    reciter: 'القراء المغاربة ورواية ورش',
    country: 'المغرب',
    countryCode: 'MA',
    countryFlag: '🇲🇦',
    url: 'https://backup.qurango.net/radio/radio_morocco',
    backupUrl: 'https://qurango.net/radio/morocco',
    category: 'شمال أفريقيا',
    description: 'الإذاعة القرآنية الرسمية للمملكة المغربية برواية ورش عن نافع والتراث الأندلسي والمغربي.'
  },
  {
    id: 'warsh-radio',
    name: 'إذاعة القراء المغاربة (رواية ورش عن نافع)',
    reciter: 'العيون الكوشي • عمر القزابري وغيرهم',
    country: 'المغرب',
    countryCode: 'MA',
    countryFlag: '🇲🇦',
    url: 'https://backup.qurango.net/radio/mahmoud_khalil_alhussary_warsh',
    backupUrl: 'https://qurango.net/radio/mahmoud_khalil_alhussary_warsh',
    category: 'شمال أفريقيا',
    description: 'تلاوات مغربية وأصوات شجية برواية ورش عن نافع من طريق الأزرق.'
  },
  {
    id: 'algeria-quran',
    name: 'إذاعة القرآن الكريم من الجزائر',
    reciter: 'الإذاعة الوطنية الجزائرية',
    country: 'الجزائر',
    countryCode: 'DZ',
    countryFlag: '🇩🇿',
    url: 'https://radiocoran.ice.infomaniak.ch/coran.mp3',
    backupUrl: 'https://backup.qurango.net/radio/radio_algeria',
    category: 'شمال أفريقيا',
    description: 'إذاعة القرآن الكريم من الجزائر العاصمة، برامج علمية وتلاوات عطرة.'
  },
  {
    id: 'zitouna-tunisia',
    name: 'إذاعة الزيتونة للقرآن الكريم - تونس',
    reciter: 'تونس الخضراء وجامع الزيتونة المعمور',
    country: 'تونس',
    countryCode: 'TN',
    countryFlag: '🇹🇳',
    url: 'https://backup.qurango.net/radio/radio_tunisia_zitouna',
    backupUrl: 'https://qurango.net/radio/tunisia_zitouna',
    category: 'شمال أفريقيا',
    description: 'صوت جامع الزيتونة التاريخي المعمور بتلاواته ورواية قالون عن نافع.'
  },

  // ================= 4. إذاعات بلاد الشام وفلسطين 🇵🇸 🇯🇴 🇱🇧 =================
  {
    id: 'quds-radio',
    name: 'إذاعة القرآن الكريم من القدس الشريف',
    reciter: 'صوت المسجد الأقصى المبارك',
    country: 'فلسطين',
    countryCode: 'PS',
    countryFlag: '🇵🇸',
    url: 'https://backup.qurango.net/radio/radio_quds',
    backupUrl: 'https://qurango.net/radio/quds',
    category: 'بلاد الشام',
    description: 'تلاوات مباركة من رحاب المسجد الأقصى المبارك والقدس الشريف أولى القبلتين.'
  },
  {
    id: 'jordan-quran',
    name: 'إذاعة القرآن الكريم من المملكة الأردنية الهاشمية',
    reciter: 'مؤسسة الإذاعة والتلفزيون الأردنية',
    country: 'الأردن',
    countryCode: 'JO',
    countryFlag: '🇯🇴',
    url: 'https://jrtv-live.ercdn.net/jrradio/quranradio.m3u8',
    category: 'بلاد الشام',
    description: 'البث القرآني اليومي من عمان - الأردن مع كبار علماء الشام.'
  },
  {
    id: 'lebanon-quran',
    name: 'إذاعة صوت القرآن الكريم من لبنان',
    reciter: 'دار الفتوى اللبنانية - بيروت',
    country: 'لبنان',
    countryCode: 'LB',
    countryFlag: '🇱🇧',
    url: 'https://backup.qurango.net/radio/radio_lebanon',
    backupUrl: 'https://qurango.net/radio/lebanon',
    category: 'بلاد الشام',
    description: 'تلاوات وبرامج إيمانية وتوجيهية من بيروت.'
  },

  // ================= 5. إذاعات دولية ولغات العالم 🌐 🇬🇧 🇫🇷 🇹🇷 🇵🇰 🇮🇩 🇪🇸 🇩🇪 =================
  {
    id: 'translation-english',
    name: 'Holy Quran with English Translation',
    reciter: 'English Audio Translation & Recitation',
    country: 'بريطانيا وأمريكا',
    countryCode: 'EN',
    countryFlag: '🇬🇧',
    url: 'https://backup.qurango.net/radio/translation_quran_english_basit',
    backupUrl: 'https://qurango.net/radio/translation_quran_english_basit',
    category: 'إذاعات دولية',
    description: 'Continuous Holy Quran recitation verse by verse followed by clear English translation.'
  },
  {
    id: 'translation-french',
    name: 'Le Saint Coran traduit en Français',
    reciter: 'Traduction et Récitation Française',
    country: 'فرنسا وأوروبا',
    countryCode: 'FR',
    countryFlag: '🇫🇷',
    url: 'https://backup.qurango.net/radio/translation_quran_french',
    backupUrl: 'https://qurango.net/radio/translation_quran_french',
    category: 'إذاعات دولية',
    description: 'Récitation du Saint Coran avec traduction des sens des versets en langue française.'
  },
  {
    id: 'translation-turkish',
    name: 'Diyanet Kur\'an-ı Kerim Radyosu - Türkiye',
    reciter: 'Türkçe Meal ve Kıraat',
    country: 'تركيا',
    countryCode: 'TR',
    countryFlag: '🇹🇷',
    url: 'https://backup.qurango.net/radio/translation_quran_turkish',
    backupUrl: 'https://qurango.net/radio/translation_quran_turkish',
    category: 'إذاعات دولية',
    description: 'Türkiye Diyanet İşleri Başkanlığı Kur\'an-ı Kerim ve Türkçe Meal Radyosu.'
  },
  {
    id: 'translation-urdu',
    name: 'قرآن کریم مع اردو ترجمہ و تفہیم',
    reciter: 'Urdu Quran Radio (Pakistan & India)',
    country: 'باكستان والهند',
    countryCode: 'PK',
    countryFlag: '🇵🇰',
    url: 'https://backup.qurango.net/radio/translation_quran_urdu_basit',
    backupUrl: 'https://qurango.net/radio/translation_quran_urdu_basit',
    category: 'إذاعات دولية',
    description: 'قرآن مجید کی پرکشش تلاوت اور ساتھ میں سلیس اردو ترجمہ اور مفاہیم۔'
  },
  {
    id: 'translation-indonesian',
    name: 'Radio Al-Qur\'an Terjemahan Bahasa Indonesia',
    reciter: 'Indonesian Audio Translation',
    country: 'إندونيسيا وماليزيا',
    countryCode: 'ID',
    countryFlag: '🇮🇩',
    url: 'https://backup.qurango.net/radio/radio_translation_quran_indonesian',
    backupUrl: 'https://qurango.net/radio/translation_quran_indonesian',
    category: 'إذاعات دولية',
    description: 'Siaran murottal Al-Qur\'an 24 jam dilengkapi dengan terjemahan bahasa Indonesia.'
  },
  {
    id: 'translation-spanish',
    name: 'El Sagrado Corán en Español',
    reciter: 'Traducción al Español',
    country: 'إسبانيا وأمريكا اللاتينية',
    countryCode: 'ES',
    countryFlag: '🇪🇸',
    url: 'https://backup.qurango.net/radio/translation_quran_spanish_afs',
    backupUrl: 'https://qurango.net/radio/translation_quran_spanish_afs',
    category: 'إذاعات دولية',
    description: 'Transmisión continua de la recitación del Corán con traducción de significados al español.'
  },
  {
    id: 'translation-german',
    name: 'Der Heilige Koran auf Deutsch',
    reciter: 'Deutsche Übersetzung',
    country: 'ألمانيا والنمسا',
    countryCode: 'DE',
    countryFlag: '🇩🇪',
    url: 'https://backup.qurango.net/radio/translation_quran_german',
    backupUrl: 'https://qurango.net/radio/translation_quran_german',
    category: 'إذاعات دولية',
    description: 'Koranrezitation mit deutscher Übersetzung rund um die Uhr.'
  },
  {
    id: 'translation-russian',
    name: 'Священный Коран на Русском языке',
    reciter: 'Русский перевод смыслов',
    country: 'روسيا وآسيا الوسطى',
    countryCode: 'RU',
    countryFlag: '🇷🇺',
    url: 'https://backup.qurango.net/radio/translation_quran_Russia',
    backupUrl: 'https://qurango.net/radio/translation_quran_Russia',
    category: 'إذاعات دولية',
    description: 'Чтение Священного Корана с построчным переводом смыслов на русский язык.'
  },

  // ================= 6. كبار القراء وأعلام التلاوة في العالم الإسلامي 🎙️ =================
  {
    id: 'abdulbasit-murattal',
    name: 'الشيخ عبد الباسط عبد الصمد (مرتل ومجود)',
    reciter: 'عبد الباسط عبد الصمد',
    country: 'مصر',
    countryCode: 'EG',
    countryFlag: '🎙️',
    url: 'https://backup.qurango.net/radio/abdulbasit_abdulsamad_mojawwad',
    backupUrl: 'https://qurango.net/radio/abdulbasit_abdulsamad_mojawwad',
    category: 'كبار القراء',
    description: 'صوت مكة الشجي وتلاوات نادرة ومجودة برواية حفص عن عاصم.'
  },
  {
    id: 'al-minshawi-murattal',
    name: 'الشيخ محمد صديق المنشاوي',
    reciter: 'محمد صديق المنشاوي',
    country: 'مصر',
    countryCode: 'EG',
    countryFlag: '🎙️',
    url: 'https://backup.qurango.net/radio/mohammed_siddiq_alminshawi',
    backupUrl: 'https://qurango.net/radio/mohammed_siddiq_alminshawi',
    category: 'كبار القراء',
    description: 'الصوت الباكي والتلاوة المتقنة برواية حفص عن عاصم.'
  },
  {
    id: 'al-husary',
    name: 'الشيخ محمود خليل الحصري',
    reciter: 'محمود خليل الحصري',
    country: 'مصر',
    countryCode: 'EG',
    countryFlag: '🎙️',
    url: 'https://backup.qurango.net/radio/mahmoud_khalil_alhussary',
    backupUrl: 'https://qurango.net/radio/mahmoud_khalil_alhussary',
    category: 'كبار القراء',
    description: 'شيخ عموم المقارئ المصرية والتلاوة المرتلة بأعلى معايير أحكام التجويد.'
  },
  {
    id: 'al-afasy',
    name: 'الشيخ مشاري راشد العفاسي',
    reciter: 'مشاري راشد العفاسي',
    country: 'الكويت',
    countryCode: 'KW',
    countryFlag: '🎙️',
    url: 'https://backup.qurango.net/radio/mishary_alafasi',
    backupUrl: 'https://qurango.net/radio/mishary_alafasi',
    category: 'كبار القراء',
    description: 'تلاوات عذبة ومؤثرة لجميع سور القرآن الكريم.'
  },
  {
    id: 'al-muaiqly',
    name: 'الشيخ ماهر المعيقلي',
    reciter: 'ماهر بن حمد المعيقلي',
    country: 'السعودية',
    countryCode: 'SA',
    countryFlag: '🎙️',
    url: 'https://backup.qurango.net/radio/maher',
    backupUrl: 'https://qurango.net/radio/maher',
    category: 'أئمة الحرمين',
    description: 'تلاوات خاشعة من إمام المسجد الحرام بمكة المكرمة.'
  },
  {
    id: 'al-sudais',
    name: 'الشيخ عبد الرحمن السديس',
    reciter: 'عبد الرحمن السديس',
    country: 'السعودية',
    countryCode: 'SA',
    countryFlag: '🎙️',
    url: 'https://backup.qurango.net/radio/abdulrahman_alsudaes',
    backupUrl: 'https://qurango.net/radio/abdulrahman_alsudaes',
    category: 'أئمة الحرمين',
    description: 'إمام وخطيب المسجد الحرام ورئيس الشؤون الدينية للمسجد الحرام والمسجد النبوي.'
  },
  {
    id: 'yasser-dossari',
    name: 'الشيخ ياسر الدوسري',
    reciter: 'ياسر بن راشد الدوسري',
    country: 'السعودية',
    countryCode: 'SA',
    countryFlag: '🎙️',
    url: 'https://backup.qurango.net/radio/yasser_aldosari',
    backupUrl: 'https://qurango.net/radio/yasser_aldosari',
    category: 'أئمة الحرمين',
    description: 'تلاوات ندية وخاشعة تأسر القلوب لإمام الحرم المكي الشريف.'
  },
  {
    id: 'saad-alghamdi',
    name: 'الشيخ سعد الغامدي',
    reciter: 'سعد الغامدي',
    country: 'السعودية',
    countryCode: 'SA',
    countryFlag: '🎙️',
    url: 'https://backup.qurango.net/radio/saad_alghamdi',
    backupUrl: 'https://qurango.net/radio/saad_alghamdi',
    category: 'كبار القراء',
    description: 'المصحف المرتل كاملاً بصوت الشيخ سعد الغامدي.'
  },
  {
    id: 'ahmed-alajmy',
    name: 'الشيخ أحمد بن علي العجمي',
    reciter: 'أحمد العجمي',
    country: 'السعودية',
    countryCode: 'SA',
    countryFlag: '🎙️',
    url: 'https://backup.qurango.net/radio/ahmad_alajmy',
    backupUrl: 'https://qurango.net/radio/ahmad_alajmy',
    category: 'كبار القراء',
    description: 'تلاوات خاشعة تريح النفس بصوت القارئ أحمد العجمي.'
  },
  {
    id: 'fares-abbad',
    name: 'الشيخ فارس عباد',
    reciter: 'فارس عباد',
    country: 'اليمن',
    countryCode: 'YE',
    countryFlag: '🇾🇪',
    url: 'https://backup.qurango.net/radio/fares_abbad',
    backupUrl: 'https://qurango.net/radio/fares_abbad',
    category: 'كبار القراء',
    description: 'تلاوات مميزة ونبرة قرآنية خاشعة للقارئ فارس عباد.'
  },
  {
    id: 'nasser-alqatami',
    name: 'الشيخ ناصر القطامي',
    reciter: 'ناصر بن علي القطامي',
    country: 'السعودية',
    countryCode: 'SA',
    countryFlag: '🎙️',
    url: 'https://backup.qurango.net/radio/nasser_alqatami',
    backupUrl: 'https://qurango.net/radio/nasser_alqatami',
    category: 'كبار القراء',
    description: 'تلاوات تراويح وقيام مؤثرة للقارئ ناصر القطامي.'
  },
  {
    id: 'idrees-abkar',
    name: 'الشيخ إدريس أبكر',
    reciter: 'إدريس بن محمد أبكر',
    country: 'السعودية',
    countryCode: 'SA',
    countryFlag: '🎙️',
    url: 'https://backup.qurango.net/radio/idrees_abkr',
    backupUrl: 'https://qurango.net/radio/idrees_abkr',
    category: 'كبار القراء',
    description: 'تلاوات شجية ومبكية تلامس المشاعر بصوت القارئ إدريس أبكر.'
  },

  // ================= 7. إذاعات الرقية الشرعية والتفسير والأذكار 📿 =================
  {
    id: 'ruqyah-radio',
    name: 'إذاعة الرقية الشرعية الشاملة',
    reciter: 'نخبة من كبار القراء',
    country: 'العالم الإسلامي',
    countryCode: 'ALL',
    countryFlag: '🛡️',
    url: 'https://backup.qurango.net/radio/roqiah',
    backupUrl: 'https://qurango.net/radio/roqiah',
    category: 'الرقية والأذكار',
    description: 'بث متواصل لآيات الرقية الشرعية والشفاء والتحصين من العين والمس والسحر.'
  },
  {
    id: 'tafsir-radio',
    name: 'إذاعة تفسير القرآن الكريم',
    reciter: 'تفسير ابن كثير والقرطبي والشعراوي والسعدي',
    country: 'العالم الإسلامي',
    countryCode: 'ALL',
    countryFlag: '📖',
    url: 'https://backup.qurango.net/radio/tafseer',
    backupUrl: 'https://qurango.net/radio/tafseer',
    category: 'التفسير والعلوم',
    description: 'شرح وتفسير آيات القرآن الكريم وتدبر معانيه العظيمة لجمهور المسلمين.'
  },
  {
    id: 'athkar-radio',
    name: 'إذاعة الأذكار وأدعية اليوم والليلة',
    reciter: 'أذكار الصباح والمساء والاستغفار',
    country: 'العالم الإسلامي',
    countryCode: 'ALL',
    countryFlag: '📿',
    url: 'https://backup.qurango.net/radio/athkar_sabah',
    backupUrl: 'https://qurango.net/radio/athkar_sabah',
    category: 'الرقية والأذكار',
    description: 'أذكار الصباح والمساء والاستيقاظ وأدعية النوم وتحصين المسلم اليومي.'
  },
  {
    id: 'khushoo-radio',
    name: 'إذاعة تلاوات خاشعة ونادرة',
    reciter: 'أصوات متعددة وتهجد الليالي',
    country: 'العالم الإسلامي',
    countryCode: 'ALL',
    countryFlag: '✨',
    url: 'https://backup.qurango.net/radio/tarateel',
    backupUrl: 'https://qurango.net/radio/tarateel',
    category: 'تلاوات خاشعة',
    description: 'تلاوات مختارة بعناية تبعث السكينة والخشوع والطمأنينة في القلوب.'
  },

  // ---------------------------------------------------------------
  // إذاعات القرّاء من الواجهة الرسمية لـ mp3quran.net — الاسم والرابط
  // من المزوّد نفسه فلا يختلفان. فُحص كلٌّ منها قبل إضافته.
  // ---------------------------------------------------------------
  {
    id: 'q-ibrahim_alakdar',
    name: 'إبراهيم الأخضر',
    reciter: 'إبراهيم الأخضر',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/ibrahim_alakdar',
    category: 'كبار القراء',
    description: 'بث مستمر — إبراهيم الأخضر'
  },
  {
    id: 'q-shaik_abu_bakr_al_shatri',
    name: 'شيخ أبو بكر الشاطري',
    reciter: 'شيخ أبو بكر الشاطري',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/shaik_abu_bakr_al_shatri',
    category: 'كبار القراء',
    description: 'بث مستمر — شيخ أبو بكر الشاطري'
  },
  {
    id: 'q-ahmad_alhawashi',
    name: 'أحمد الحواشي',
    reciter: 'أحمد الحواشي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/ahmad_alhawashi',
    category: 'كبار القراء',
    description: 'بث مستمر — أحمد الحواشي'
  },
  {
    id: 'q-ahmad_saber',
    name: 'أحمد صابر',
    reciter: 'أحمد صابر',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/ahmad_saber',
    category: 'كبار القراء',
    description: 'بث مستمر — أحمد صابر'
  },
  {
    id: 'q-ahmad_nauina',
    name: 'أحمد نعينع',
    reciter: 'أحمد نعينع',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/ahmad_nauina',
    category: 'كبار القراء',
    description: 'بث مستمر — أحمد نعينع'
  },
  {
    id: 'q-akram_alalaqmi',
    name: 'أكرم العلاقمي',
    reciter: 'أكرم العلاقمي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/akram_alalaqmi',
    category: 'كبار القراء',
    description: 'بث مستمر — أكرم العلاقمي'
  },
  {
    id: 'q-alzain_mohammad_ahmad',
    name: 'الزين محمد أحمد',
    reciter: 'الزين محمد أحمد',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/alzain_mohammad_ahmad',
    category: 'كبار القراء',
    description: 'بث مستمر — الزين محمد أحمد'
  },
  {
    id: 'q-alqaria_yassen',
    name: 'القارئ ياسين',
    reciter: 'القارئ ياسين',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/alqaria_yassen',
    category: 'كبار القراء',
    description: 'بث مستمر — القارئ ياسين'
  },
  {
    id: 'q-aloyoon_alkoshi',
    name: 'العيون الكوشي',
    reciter: 'العيون الكوشي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/aloyoon_alkoshi',
    category: 'كبار القراء',
    description: 'بث مستمر — العيون الكوشي'
  },
  {
    id: 'q-tawfeeq_assayegh',
    name: 'توفيق الصايغ',
    reciter: 'توفيق الصايغ',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/tawfeeq_assayegh',
    category: 'كبار القراء',
    description: 'بث مستمر — توفيق الصايغ'
  },
  {
    id: 'q-jamal_shaker_abdullah',
    name: 'جمال شاكر عبدالله',
    reciter: 'جمال شاكر عبدالله',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/jamal_shaker_abdullah',
    category: 'كبار القراء',
    description: 'بث مستمر — جمال شاكر عبدالله'
  },
  {
    id: 'q-khaled_alqahtani',
    name: 'خالد القحطاني',
    reciter: 'خالد القحطاني',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/khaled_alqahtani',
    category: 'كبار القراء',
    description: 'بث مستمر — خالد القحطاني'
  },
  {
    id: 'q-khalid_abdulkafi',
    name: 'خالد عبدالكافي',
    reciter: 'خالد عبدالكافي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/khalid_abdulkafi',
    category: 'كبار القراء',
    description: 'بث مستمر — خالد عبدالكافي'
  },
  {
    id: 'q-khalifa_altunaiji',
    name: 'خليفة الطنيجي',
    reciter: 'خليفة الطنيجي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/khalifa_altunaiji',
    category: 'كبار القراء',
    description: 'بث مستمر — خليفة الطنيجي'
  },
  {
    id: 'q-saud_alshuraim',
    name: 'سعود الشريم',
    reciter: 'سعود الشريم',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/saud_alshuraim',
    category: 'كبار القراء',
    description: 'بث مستمر — سعود الشريم'
  },
  {
    id: 'q-sahl_yassin',
    name: 'سهل ياسين',
    reciter: 'سهل ياسين',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/sahl_yassin',
    category: 'كبار القراء',
    description: 'بث مستمر — سهل ياسين'
  },
  {
    id: 'q-zaki_daghistani',
    name: 'زكي داغستاني',
    reciter: 'زكي داغستاني',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/zaki_daghistani',
    category: 'كبار القراء',
    description: 'بث مستمر — زكي داغستاني'
  },
  {
    id: 'q-sayeed_ramadan',
    name: 'سيد رمضان',
    reciter: 'سيد رمضان',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/sayeed_ramadan',
    category: 'كبار القراء',
    description: 'بث مستمر — سيد رمضان'
  },
  {
    id: 'q-shirazad_taher',
    name: 'شيرزاد عبدالرحمن طاهر',
    reciter: 'شيرزاد عبدالرحمن طاهر',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/shirazad_taher',
    category: 'كبار القراء',
    description: 'بث مستمر — شيرزاد عبدالرحمن طاهر'
  },
  {
    id: 'q-saber_abdulhakm',
    name: 'صابر عبدالحكم',
    reciter: 'صابر عبدالحكم',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/saber_abdulhakm',
    category: 'كبار القراء',
    description: 'بث مستمر — صابر عبدالحكم'
  },
  {
    id: 'q-salah_albudair',
    name: 'صلاح البدير',
    reciter: 'صلاح البدير',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/salah_albudair',
    category: 'كبار القراء',
    description: 'بث مستمر — صلاح البدير'
  },
  {
    id: 'q-salah_alhashim',
    name: 'صلاح الهاشم',
    reciter: 'صلاح الهاشم',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/salah_alhashim',
    category: 'كبار القراء',
    description: 'بث مستمر — صلاح الهاشم'
  },
  {
    id: 'q-slaah_bukhatir',
    name: 'صلاح بو خاطر',
    reciter: 'صلاح بو خاطر',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/slaah_bukhatir',
    category: 'كبار القراء',
    description: 'بث مستمر — صلاح بو خاطر'
  },
  {
    id: 'q-adel_ryyan',
    name: 'عادل ريان',
    reciter: 'عادل ريان',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/adel_ryyan',
    category: 'كبار القراء',
    description: 'بث مستمر — عادل ريان'
  },
  {
    id: 'q-abdelbari_altoubayti',
    name: 'عبدالبارئ الثبيتي',
    reciter: 'عبدالبارئ الثبيتي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdelbari_altoubayti',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالبارئ الثبيتي'
  },
  {
    id: 'q-abdulbari_mohammad',
    name: 'عبدالبارئ محمد',
    reciter: 'عبدالبارئ محمد',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdulbari_mohammad',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالبارئ محمد'
  },
  {
    id: 'q-abdulbasit_abdulsamad_warsh',
    name: 'عبدالباسط عبدالصمد',
    reciter: 'عبدالباسط عبدالصمد',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdulbasit_abdulsamad_warsh',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالباسط عبدالصمد'
  },
  {
    id: 'q-abdulbasit_abdulsamad',
    name: 'عبدالباسط عبدالصمد',
    reciter: 'عبدالباسط عبدالصمد',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdulbasit_abdulsamad',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالباسط عبدالصمد'
  },
  {
    id: 'q-abdul_aziz_alahmad',
    name: 'عبدالعزيز الأحمد',
    reciter: 'عبدالعزيز الأحمد',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdul_aziz_alahmad',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالعزيز الأحمد'
  },
  {
    id: 'q-abdullah_almattrod',
    name: 'عبدالله المطرود',
    reciter: 'عبدالله المطرود',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdullah_almattrod',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالله المطرود'
  },
  {
    id: 'q-abdullah_basfer',
    name: 'عبدالله بصفر',
    reciter: 'عبدالله بصفر',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdullah_basfer',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالله بصفر'
  },
  {
    id: 'q-abdullah_khayyat',
    name: 'عبدالله خياط',
    reciter: 'عبدالله خياط',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdullah_khayyat',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالله خياط'
  },
  {
    id: 'q-abdullah_aljohany',
    name: 'عبدالله عواد الجهني',
    reciter: 'عبدالله عواد الجهني',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdullah_aljohany',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالله عواد الجهني'
  },
  {
    id: 'q-abdulrasheed_soufi_khalaf',
    name: 'عبدالرشيد صوفي',
    reciter: 'عبدالرشيد صوفي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdulrasheed_soufi_khalaf',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالرشيد صوفي'
  },
  {
    id: 'q-abdulrasheed_soufi_assosi',
    name: 'عبدالرشيد صوفي',
    reciter: 'عبدالرشيد صوفي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdulrasheed_soufi_assosi',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالرشيد صوفي'
  },
  {
    id: 'q-abdulmohsin_alharthy',
    name: 'عبدالمحسن الحارثي',
    reciter: 'عبدالمحسن الحارثي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdulmohsin_alharthy',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالمحسن الحارثي'
  },
  {
    id: 'q-abdulmohsen_alqasim',
    name: 'عبدالمحسن القاسم',
    reciter: 'عبدالمحسن القاسم',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdulmohsen_alqasim',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالمحسن القاسم'
  },
  {
    id: 'q-abdulmohsin_alobaikan',
    name: 'عبدالمحسن العبيكان',
    reciter: 'عبدالمحسن العبيكان',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdulmohsin_alobaikan',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالمحسن العبيكان'
  },
  {
    id: 'q-abdulhadi_kanakeri',
    name: 'عبدالهادي أحمد كناكري',
    reciter: 'عبدالهادي أحمد كناكري',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdulhadi_kanakeri',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالهادي أحمد كناكري'
  },
  {
    id: 'q-abdulwadood_haneef',
    name: 'عبدالودود حنيف',
    reciter: 'عبدالودود حنيف',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdulwadood_haneef',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالودود حنيف'
  },
  {
    id: 'q-ali_alhuthaifi',
    name: 'علي بن عبدالرحمن الحذيفي',
    reciter: 'علي بن عبدالرحمن الحذيفي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/ali_alhuthaifi',
    category: 'كبار القراء',
    description: 'بث مستمر — علي بن عبدالرحمن الحذيفي'
  },
  {
    id: 'q-ali_alhuthaifi_qalon',
    name: 'علي الحذيفي',
    reciter: 'علي الحذيفي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/ali_alhuthaifi_qalon',
    category: 'كبار القراء',
    description: 'بث مستمر — علي الحذيفي'
  },
  {
    id: 'q-ali_jaber',
    name: 'علي جابر',
    reciter: 'علي جابر',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/ali_jaber',
    category: 'كبار القراء',
    description: 'بث مستمر — علي جابر'
  },
  {
    id: 'q-ali_hajjaj_alsouasi',
    name: 'علي حجاج السويسي',
    reciter: 'علي حجاج السويسي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/ali_hajjaj_alsouasi',
    category: 'كبار القراء',
    description: 'بث مستمر — علي حجاج السويسي'
  },
  {
    id: 'q-emad_hafez',
    name: 'عماد زهير حافظ',
    reciter: 'عماد زهير حافظ',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/emad_hafez',
    category: 'كبار القراء',
    description: 'بث مستمر — عماد زهير حافظ'
  },
  {
    id: 'q-omar_alqazabri',
    name: 'عمر القزابري',
    reciter: 'عمر القزابري',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/omar_alqazabri',
    category: 'كبار القراء',
    description: 'بث مستمر — عمر القزابري'
  },
  {
    id: 'q-nabil_al_rifay',
    name: 'نبيل الرفاعي',
    reciter: 'نبيل الرفاعي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/nabil_al_rifay',
    category: 'كبار القراء',
    description: 'بث مستمر — نبيل الرفاعي'
  },
  {
    id: 'q-neamah_alhassan',
    name: 'نعمة الحسان',
    reciter: 'نعمة الحسان',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/neamah_alhassan',
    category: 'كبار القراء',
    description: 'بث مستمر — نعمة الحسان'
  },
  {
    id: 'q-hani_arrifai',
    name: 'هاني الرفاعي',
    reciter: 'هاني الرفاعي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/hani_arrifai',
    category: 'كبار القراء',
    description: 'بث مستمر — هاني الرفاعي'
  },
  {
    id: 'q-waleed_alnaehi',
    name: 'وليد النائحي',
    reciter: 'وليد النائحي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/waleed_alnaehi',
    category: 'كبار القراء',
    description: 'بث مستمر — وليد النائحي'
  },
  {
    id: 'q-yasser_alqurashi',
    name: 'ياسر القرشي',
    reciter: 'ياسر القرشي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/yasser_alqurashi',
    category: 'كبار القراء',
    description: 'بث مستمر — ياسر القرشي'
  },
  {
    id: 'q-yasser_almazroyee',
    name: 'ياسر المزروعي',
    reciter: 'ياسر المزروعي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/yasser_almazroyee',
    category: 'كبار القراء',
    description: 'بث مستمر — ياسر المزروعي'
  },
  {
    id: 'q-yahya_hawwa',
    name: 'يحيى حوا',
    reciter: 'يحيى حوا',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/yahya_hawwa',
    category: 'كبار القراء',
    description: 'بث مستمر — يحيى حوا'
  },
  {
    id: 'q-yousef_alshoaey',
    name: 'يوسف الشويعي',
    reciter: 'يوسف الشويعي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/yousef_alshoaey',
    category: 'كبار القراء',
    description: 'بث مستمر — يوسف الشويعي'
  },
  {
    id: 'q-mohammad_altablaway',
    name: 'محمد الطبلاوي',
    reciter: 'محمد الطبلاوي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mohammad_altablaway',
    category: 'كبار القراء',
    description: 'بث مستمر — محمد الطبلاوي'
  },
  {
    id: 'q-mohammed_allohaidan',
    name: 'محمد اللحيدان',
    reciter: 'محمد اللحيدان',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mohammed_allohaidan',
    category: 'كبار القراء',
    description: 'بث مستمر — محمد اللحيدان'
  },
  {
    id: 'q-mohammed_ayyub',
    name: 'محمد أيوب',
    reciter: 'محمد أيوب',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mohammed_ayyub',
    category: 'كبار القراء',
    description: 'بث مستمر — محمد أيوب'
  },
  {
    id: 'q-mohammad_saleh_alim_shah',
    name: 'محمد صالح عالم شاه',
    reciter: 'محمد صالح عالم شاه',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mohammad_saleh_alim_shah',
    category: 'كبار القراء',
    description: 'بث مستمر — محمد صالح عالم شاه'
  },
  {
    id: 'q-mohammed_jibreel',
    name: 'محمد جبريل',
    reciter: 'محمد جبريل',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mohammed_jibreel',
    category: 'كبار القراء',
    description: 'بث مستمر — محمد جبريل'
  },
  {
    id: 'q-mohammed_siddiq_alminshawi_mojawwad',
    name: 'محمد صديق المنشاوي',
    reciter: 'محمد صديق المنشاوي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mohammed_siddiq_alminshawi_mojawwad',
    category: 'كبار القراء',
    description: 'بث مستمر — محمد صديق المنشاوي'
  },
  {
    id: 'q-mohammad_abdullkarem',
    name: 'محمد عبدالكريم',
    reciter: 'محمد عبدالكريم',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mohammad_abdullkarem',
    category: 'كبار القراء',
    description: 'بث مستمر — محمد عبدالكريم'
  },
  {
    id: 'q-mohammad_alabdullah_albizi',
    name: 'محمد عبدالحكيم سعيد العبدالله',
    reciter: 'محمد عبدالحكيم سعيد العبدالله',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mohammad_alabdullah_albizi',
    category: 'كبار القراء',
    description: 'بث مستمر — محمد عبدالحكيم سعيد العبدالله'
  },
  {
    id: 'q-mohammad_alabdullah_aldorai',
    name: 'محمد عبدالحكيم سعيد العبدالله',
    reciter: 'محمد عبدالحكيم سعيد العبدالله',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mohammad_alabdullah_aldorai',
    category: 'كبار القراء',
    description: 'بث مستمر — محمد عبدالحكيم سعيد العبدالله'
  },
  {
    id: 'q-mahmoud_khalil_alhussary_mojawwad',
    name: 'محمود خليل الحصري',
    reciter: 'محمود خليل الحصري',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mahmoud_khalil_alhussary_mojawwad',
    category: 'كبار القراء',
    description: 'بث مستمر — محمود خليل الحصري'
  },
  {
    id: 'q-mahmoud_ali__albanna',
    name: 'محمود علي البنا',
    reciter: 'محمود علي البنا',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mahmoud_ali__albanna',
    category: 'كبار القراء',
    description: 'بث مستمر — محمود علي البنا'
  },
  {
    id: 'q-mahmoud_ali__albanna_mojawwad',
    name: 'محمود علي البنا',
    reciter: 'محمود علي البنا',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mahmoud_ali__albanna_mojawwad',
    category: 'كبار القراء',
    description: 'بث مستمر — محمود علي البنا'
  },
  {
    id: 'q-mustafa_ismail',
    name: 'مصطفى إسماعيل',
    reciter: 'مصطفى إسماعيل',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mustafa_ismail',
    category: 'كبار القراء',
    description: 'بث مستمر — مصطفى إسماعيل'
  },
  {
    id: 'q-mustafa_allahoni',
    name: 'مصطفى اللاهوني',
    reciter: 'مصطفى اللاهوني',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mustafa_allahoni',
    category: 'كبار القراء',
    description: 'بث مستمر — مصطفى اللاهوني'
  },
  {
    id: 'q-mustafa_raad_alazawy',
    name: 'مصطفى رعد العزاوي',
    reciter: 'مصطفى رعد العزاوي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mustafa_raad_alazawy',
    category: 'كبار القراء',
    description: 'بث مستمر — مصطفى رعد العزاوي'
  },
  {
    id: 'q-muftah_alsaltany_aldori_an_abi_amr',
    name: 'مفتاح السلطني',
    reciter: 'مفتاح السلطني',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/muftah_alsaltany_aldori_an_abi_amr',
    category: 'كبار القراء',
    description: 'بث مستمر — مفتاح السلطني'
  },
  {
    id: 'q-maher_shakhashero',
    name: 'ماهر شخاشيرو',
    reciter: 'ماهر شخاشيرو',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/maher_shakhashero',
    category: 'كبار القراء',
    description: 'بث مستمر — ماهر شخاشيرو'
  },
  {
    id: 'q-mahmood_alsheimy',
    name: 'محمود الشيمي',
    reciter: 'محمود الشيمي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mahmood_alsheimy',
    category: 'كبار القراء',
    description: 'بث مستمر — محمود الشيمي'
  },
  {
    id: 'q-khalid_almohana',
    name: 'خالد المهنا',
    reciter: 'خالد المهنا',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/khalid_almohana',
    category: 'كبار القراء',
    description: 'بث مستمر — خالد المهنا'
  },
  {
    id: 'q-adel_alkhalbany',
    name: 'عادل الكلباني',
    reciter: 'عادل الكلباني',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/adel_alkhalbany',
    category: 'كبار القراء',
    description: 'بث مستمر — عادل الكلباني'
  },
  {
    id: 'q-mousa_bilal',
    name: 'موسى بلال',
    reciter: 'موسى بلال',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mousa_bilal',
    category: 'كبار القراء',
    description: 'بث مستمر — موسى بلال'
  },
  {
    id: 'q-hatem_fareed_alwaer',
    name: 'حاتم فريد الواعر',
    reciter: 'حاتم فريد الواعر',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/hatem_fareed_alwaer',
    category: 'كبار القراء',
    description: 'بث مستمر — حاتم فريد الواعر'
  },
  {
    id: 'q-mahmood_al_rifai',
    name: 'محمود الرفاعي',
    reciter: 'محمود الرفاعي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mahmood_al_rifai',
    category: 'كبار القراء',
    description: 'بث مستمر — محمود الرفاعي'
  },
  {
    id: 'q-ibrahim_aldosari',
    name: 'ابراهيم الدوسري',
    reciter: 'ابراهيم الدوسري',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/ibrahim_aldosari',
    category: 'كبار القراء',
    description: 'بث مستمر — ابراهيم الدوسري'
  },
  {
    id: 'q-muftah_alsaltany_aldorai',
    name: 'مفتاح السلطني',
    reciter: 'مفتاح السلطني',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/muftah_alsaltany_aldorai',
    category: 'كبار القراء',
    description: 'بث مستمر — مفتاح السلطني'
  },
  {
    id: 'q-jamaan_alosaimi',
    name: 'جمعان العصيمي',
    reciter: 'جمعان العصيمي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/jamaan_alosaimi',
    category: 'كبار القراء',
    description: 'بث مستمر — جمعان العصيمي'
  },
  {
    id: 'q-yousef_bin_noah_ahmad',
    name: 'يوسف بن نوح أحمد',
    reciter: 'يوسف بن نوح أحمد',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/yousef_bin_noah_ahmad',
    category: 'كبار القراء',
    description: 'بث مستمر — يوسف بن نوح أحمد'
  },
  {
    id: 'q-muftah_alsaltany_ibn_thakwan_an_ibn_amr',
    name: 'مفتاح السلطني',
    reciter: 'مفتاح السلطني',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/muftah_alsaltany_ibn_thakwan_an_ibn_amr',
    category: 'كبار القراء',
    description: 'بث مستمر — مفتاح السلطني'
  },
  {
    id: 'q-moeedh_alharthi',
    name: 'معيض الحارثي',
    reciter: 'معيض الحارثي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/moeedh_alharthi',
    category: 'كبار القراء',
    description: 'بث مستمر — معيض الحارثي'
  },
  {
    id: 'q-mohammad_rashad_alshareef',
    name: 'محمد رشاد الشريف',
    reciter: 'محمد رشاد الشريف',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mohammad_rashad_alshareef',
    category: 'كبار القراء',
    description: 'بث مستمر — محمد رشاد الشريف'
  },
  {
    id: 'q-ahmad_khader_altarabulsi',
    name: 'أحمد خضر الطرابلسي',
    reciter: 'أحمد خضر الطرابلسي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/ahmad_khader_altarabulsi',
    category: 'كبار القراء',
    description: 'بث مستمر — أحمد خضر الطرابلسي'
  },
  {
    id: 'q-ahmed_altrabulsi',
    name: 'أحمد الطرابلسي',
    reciter: 'أحمد الطرابلسي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/ahmed_altrabulsi',
    category: 'كبار القراء',
    description: 'بث مستمر — أحمد الطرابلسي'
  },
  {
    id: 'q-abdullah_alkandari',
    name: 'عبدالله الكندري',
    reciter: 'عبدالله الكندري',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdullah_alkandari',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالله الكندري'
  },
  {
    id: 'q-ahmed_amer',
    name: 'أحمد عامر',
    reciter: 'أحمد عامر',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/ahmed_amer',
    category: 'كبار القراء',
    description: 'بث مستمر — أحمد عامر'
  },
  {
    id: 'q-mohammed_osman_khan',
    name: 'محمد عثمان خان',
    reciter: 'محمد عثمان خان',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mohammed_osman_khan',
    category: 'كبار القراء',
    description: 'بث مستمر — محمد عثمان خان'
  },
  {
    id: 'q-addokali_mohammad_alalim',
    name: 'الدوكالي محمد العالم',
    reciter: 'الدوكالي محمد العالم',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/addokali_mohammad_alalim',
    category: 'كبار القراء',
    description: 'بث مستمر — الدوكالي محمد العالم'
  },
  {
    id: 'q-mohammad_abdullkarem_alasbahani',
    name: 'محمد عبدالكريم',
    reciter: 'محمد عبدالكريم',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mohammad_abdullkarem_alasbahani',
    category: 'كبار القراء',
    description: 'بث مستمر — محمد عبدالكريم'
  },
  {
    id: 'q-alfateh_alzubair',
    name: 'الفاتح محمد الزبير',
    reciter: 'الفاتح محمد الزبير',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/alfateh_alzubair',
    category: 'كبار القراء',
    description: 'بث مستمر — الفاتح محمد الزبير'
  },
  {
    id: 'q-tareq_abdulgani_daawob',
    name: 'طارق عبدالغني دعوب',
    reciter: 'طارق عبدالغني دعوب',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/tareq_abdulgani_daawob',
    category: 'كبار القراء',
    description: 'بث مستمر — طارق عبدالغني دعوب'
  },
  {
    id: 'q-mix',
    name: 'العامة - متنوعة لمختلف القراء',
    reciter: 'العامة - متنوعة لمختلف القراء',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mix',
    category: 'كبار القراء',
    description: 'بث مستمر — العامة - متنوعة لمختلف القراء'
  },
  {
    id: 'q-salma',
    name: 'تلاوات خاشعة-',
    reciter: 'تلاوات خاشعة-',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/salma',
    category: 'كبار القراء',
    description: 'بث مستمر — تلاوات خاشعة-'
  },
  {
    id: 'q-eid',
    name: 'تكبيرات العيد',
    reciter: 'تكبيرات العيد',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/eid',
    category: 'كبار القراء',
    description: 'بث مستمر — تكبيرات العيد'
  },
  {
    id: 'q-abdulrahman_almajed',
    name: 'عبدالرحمن الماجد',
    reciter: 'عبدالرحمن الماجد',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdulrahman_almajed',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالرحمن الماجد'
  },
  {
    id: 'q-fatwa',
    name: 'الفتاوى العامة',
    reciter: 'الفتاوى العامة',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/fatwa',
    category: 'كبار القراء',
    description: 'بث مستمر — الفتاوى العامة'
  },
  {
    id: 'q-khalid_aljileel',
    name: 'خالد الجليل',
    reciter: 'خالد الجليل',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/khalid_aljileel',
    category: 'كبار القراء',
    description: 'بث مستمر — خالد الجليل'
  },
  {
    id: 'q-nasser_almajed',
    name: 'ناصر الماجد',
    reciter: 'ناصر الماجد',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/nasser_almajed',
    category: 'كبار القراء',
    description: 'بث مستمر — ناصر الماجد'
  },
  {
    id: 'q-hitham_aljadani',
    name: 'هيثم الجدعاني',
    reciter: 'هيثم الجدعاني',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/hitham_aljadani',
    category: 'كبار القراء',
    description: 'بث مستمر — هيثم الجدعاني'
  },
  {
    id: 'q-ahmad_shaheen',
    name: 'أحمد خليل شاهين',
    reciter: 'أحمد خليل شاهين',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/ahmad_shaheen',
    category: 'كبار القراء',
    description: 'بث مستمر — أحمد خليل شاهين'
  },
  {
    id: 'q-abdullah_alkhalaf',
    name: 'عبدالله الخلف',
    reciter: 'عبدالله الخلف',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/abdullah_alkhalaf',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالله الخلف'
  },
  {
    id: 'q-majed_alzamel',
    name: 'ماجد الزامل',
    reciter: 'ماجد الزامل',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/majed_alzamel',
    category: 'كبار القراء',
    description: 'بث مستمر — ماجد الزامل'
  },
  {
    id: 'q-bandar_balilah',
    name: 'بندر بليلة',
    reciter: 'بندر بليلة',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/bandar_balilah',
    category: 'كبار القراء',
    description: 'بث مستمر — بندر بليلة'
  },
  {
    id: 'q-nasser_alosfor',
    name: 'ناصر العصفور',
    reciter: 'ناصر العصفور',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/nasser_alosfor',
    category: 'كبار القراء',
    description: 'بث مستمر — ناصر العصفور'
  },
  {
    id: 'q-ahmad_deban',
    name: 'أحمد ديبان',
    reciter: 'أحمد ديبان',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/ahmad_deban',
    category: 'كبار القراء',
    description: 'بث مستمر — أحمد ديبان'
  },
  {
    id: 'q-sneineh',
    name: 'أذاعة محمد أبوسنينة',
    reciter: 'أذاعة محمد أبوسنينة',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/sneineh',
    category: 'كبار القراء',
    description: 'بث مستمر — أذاعة محمد أبوسنينة'
  },
  {
    id: 'q-qeniwa',
    name: 'محمد الأمين قنيوة',
    reciter: 'محمد الأمين قنيوة',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/qeniwa',
    category: 'كبار القراء',
    description: 'بث مستمر — محمد الأمين قنيوة'
  },
  {
    id: 'q-a_alshahhat',
    name: 'عبدالرحمن الشحات',
    reciter: 'عبدالرحمن الشحات',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/a_alshahhat',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالرحمن الشحات'
  },
  {
    id: 'q-a_sheim',
    name: 'عبدالعزيز سحيم',
    reciter: 'عبدالعزيز سحيم',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/a_sheim',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالعزيز سحيم'
  },
  {
    id: 'q-sakeenah',
    name: 'آيات السكينة',
    reciter: 'آيات السكينة',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/sakeenah',
    category: 'كبار القراء',
    description: 'بث مستمر — آيات السكينة'
  },
  {
    id: 'q-sahabah',
    name: 'صور من حياة الصحابة والتابعين رضوان الله عليهم---',
    reciter: 'صور من حياة الصحابة والتابعين رضوان الله عليهم---',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/sahabah',
    category: 'كبار القراء',
    description: 'بث مستمر — صور من حياة الصحابة والتابعين رضوان الله عليهم---'
  },
  {
    id: 'q-mukhtasartafsir',
    name: 'المختصر في تفسير القرآن الكريم',
    reciter: 'المختصر في تفسير القرآن الكريم',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/mukhtasartafsir',
    category: 'التفسير والعلوم',
    description: 'بث مستمر — المختصر في تفسير القرآن الكريم'
  },
  {
    id: 'q-athkar_masa',
    name: 'أذكار المساء',
    reciter: 'أذكار المساء',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/athkar_masa',
    category: 'الرقية والأذكار',
    description: 'بث مستمر — أذكار المساء'
  },
  {
    id: 'q-fi_zilal_alsiyra',
    name: 'في ظلال السيرة النبوية - 400 حلقة عن سيرة نبينا محمد صلى الله عليه وسلم',
    reciter: 'في ظلال السيرة النبوية - 400 حلقة عن سيرة نبينا محمد صلى الله عليه وسلم',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/fi_zilal_alsiyra',
    category: 'كبار القراء',
    description: 'بث مستمر — في ظلال السيرة النبوية - 400 حلقة عن سيرة نبينا محمد صلى الله عليه وسلم'
  },
  {
    id: 'q-almukhtasar_fi_alsiyra',
    name: 'المختصر في السيرة النبوية',
    reciter: 'المختصر في السيرة النبوية',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/almukhtasar_fi_alsiyra',
    category: 'كبار القراء',
    description: 'بث مستمر — المختصر في السيرة النبوية'
  },
  {
    id: 'q-alaikhtiarat_alfiqhayh_bin_baz',
    name: 'كتاب الاختيارات الفقهية في مسائل العبادات والمعاملات',
    reciter: 'كتاب الاختيارات الفقهية في مسائل العبادات والمعاملات',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/alaikhtiarat_alfiqhayh_bin_baz',
    category: 'التفسير والعلوم',
    description: 'بث مستمر — كتاب الاختيارات الفقهية في مسائل العبادات والمعاملات'
  },
  {
    id: 'q-tabri',
    name: 'تفسير القران الكريم-الخلاصة من تفسير الطبري',
    reciter: 'تفسير القران الكريم-الخلاصة من تفسير الطبري',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/tabri',
    category: 'التفسير والعلوم',
    description: 'بث مستمر — تفسير القران الكريم-الخلاصة من تفسير الطبري'
  },
  {
    id: 'q-saleh_alhabdan',
    name: 'صالح الهبدان',
    reciter: 'صالح الهبدان',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/saleh_alhabdan',
    category: 'كبار القراء',
    description: 'بث مستمر — صالح الهبدان'
  },
  {
    id: 'q-translation_quran_albanian',
    name: 'ترجمة معاني القرآن باللغة الألبانية',
    reciter: 'ترجمة معاني القرآن باللغة الألبانية',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/translation_quran_albanian',
    category: 'إذاعات دولية',
    description: 'بث مستمر — ترجمة معاني القرآن باللغة الألبانية'
  },
  {
    id: 'q-translation_quran_tamazight',
    name: 'ترجمة معاني القرآن باللغة الأمازيغية',
    reciter: 'ترجمة معاني القرآن باللغة الأمازيغية',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/translation_quran_tamazight',
    category: 'إذاعات دولية',
    description: 'بث مستمر — ترجمة معاني القرآن باللغة الأمازيغية'
  },
  {
    id: 'q-translation_quran_urdu_sds_shur',
    name: 'ترجمة معاني القرآن باللغة الأوردية',
    reciter: 'ترجمة معاني القرآن باللغة الأوردية',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/translation_quran_urdu_sds_shur',
    category: 'إذاعات دولية',
    description: 'بث مستمر — ترجمة معاني القرآن باللغة الأوردية'
  },
  {
    id: 'q-translation_quran_urdu_minsh',
    name: 'ترجمة معاني القرآن باللغة الأوردية',
    reciter: 'ترجمة معاني القرآن باللغة الأوردية',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/translation_quran_urdu_minsh',
    category: 'إذاعات دولية',
    description: 'بث مستمر — ترجمة معاني القرآن باللغة الأوردية'
  },
  {
    id: 'q-translation_quran_english_bsfr',
    name: 'ترجمة معاني القرآن باللغة الإنجليزية',
    reciter: 'ترجمة معاني القرآن باللغة الإنجليزية',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/translation_quran_english_bsfr',
    category: 'إذاعات دولية',
    description: 'بث مستمر — ترجمة معاني القرآن باللغة الإنجليزية'
  },
  {
    id: 'q-translation_quran_english_walk_basit',
    name: 'ترجمة معاني القرآن باللغة الإنجليزية -ترجمة والك-',
    reciter: 'ترجمة معاني القرآن باللغة الإنجليزية -ترجمة والك-',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/translation_quran_english_walk_basit',
    category: 'إذاعات دولية',
    description: 'بث مستمر — ترجمة معاني القرآن باللغة الإنجليزية -ترجمة والك-'
  },
  {
    id: 'q-translation_quran_portuguese',
    name: 'ترجمة معاني القرآن باللغة البرتغالية',
    reciter: 'ترجمة معاني القرآن باللغة البرتغالية',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/translation_quran_portuguese',
    category: 'إذاعات دولية',
    description: 'بث مستمر — ترجمة معاني القرآن باللغة البرتغالية'
  },
  {
    id: 'q-translation_quran_bosnia',
    name: 'ترجمة معاني القرآن باللغة البوسنية',
    reciter: 'ترجمة معاني القرآن باللغة البوسنية',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/translation_quran_bosnia',
    category: 'إذاعات دولية',
    description: 'بث مستمر — ترجمة معاني القرآن باللغة البوسنية'
  },
  {
    id: 'q-translation_quran_chinese',
    name: 'ترجمة معاني القرآن باللغة الصينية',
    reciter: 'ترجمة معاني القرآن باللغة الصينية',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/translation_quran_chinese',
    category: 'إذاعات دولية',
    description: 'بث مستمر — ترجمة معاني القرآن باللغة الصينية'
  },
  {
    id: 'q-translation_quran_farsi',
    name: 'ترجمة معاني القرآن باللغة الفارسية',
    reciter: 'ترجمة معاني القرآن باللغة الفارسية',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/translation_quran_farsi',
    category: 'إذاعات دولية',
    description: 'بث مستمر — ترجمة معاني القرآن باللغة الفارسية'
  },
  {
    id: 'q-translation_quran_kurdish',
    name: 'ترجمة معاني القرآن باللغة الكردية',
    reciter: 'ترجمة معاني القرآن باللغة الكردية',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/translation_quran_kurdish',
    category: 'إذاعات دولية',
    description: 'بث مستمر — ترجمة معاني القرآن باللغة الكردية'
  },
  {
    id: 'q-translation_quran_hungarian',
    name: 'ترجمة معاني القرآن باللغة المجرية',
    reciter: 'ترجمة معاني القرآن باللغة المجرية',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/translation_quran_hungarian',
    category: 'إذاعات دولية',
    description: 'بث مستمر — ترجمة معاني القرآن باللغة المجرية'
  },
  {
    id: 'q-translation_quran_greek',
    name: 'ترجمة معاني القرآن باللغة اليونانية',
    reciter: 'ترجمة معاني القرآن باللغة اليونانية',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/translation_quran_greek',
    category: 'إذاعات دولية',
    description: 'بث مستمر — ترجمة معاني القرآن باللغة اليونانية'
  },
  {
    id: 'q-Surah_Al-Mulk',
    name: 'سورة الملك',
    reciter: 'سورة الملك',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/Surah_Al-Mulk',
    category: 'تلاوات خاشعة',
    description: 'بث مستمر — سورة الملك'
  },
  {
    id: 'q-ramadan',
    name: 'فضل شهر رمضان',
    reciter: 'فضل شهر رمضان',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/ramadan',
    category: 'كبار القراء',
    description: 'بث مستمر — فضل شهر رمضان'
  },
  {
    id: 'q-Translation_Quran_Hausa',
    name: 'ترجمة معاني القرآن باللغة الهوسا',
    reciter: 'ترجمة معاني القرآن باللغة الهوسا',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/Translation_Quran_Hausa',
    category: 'إذاعات دولية',
    description: 'بث مستمر — ترجمة معاني القرآن باللغة الهوسا'
  },
  {
    id: 'q-saheh-muslim',
    name: 'صحيح مسلم',
    reciter: 'صحيح مسلم',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/saheh-muslim',
    category: 'كبار القراء',
    description: 'بث مستمر — صحيح مسلم'
  },
  {
    id: 'q-saheh-bokharee',
    name: 'صحيح البخاري',
    reciter: 'صحيح البخاري',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/saheh-bokharee',
    category: 'كبار القراء',
    description: 'بث مستمر — صحيح البخاري'
  },
  {
    id: 'q-alanbiya',
    name: '***قصص الأنبياء***',
    reciter: '***قصص الأنبياء***',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/alanbiya',
    category: 'كبار القراء',
    description: 'بث مستمر — ***قصص الأنبياء***'
  },
  {
    id: 'q-riyad',
    name: 'رياض الصالحين',
    reciter: 'رياض الصالحين',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/riyad',
    category: 'كبار القراء',
    description: 'بث مستمر — رياض الصالحين'
  },
  {
    id: 'q-buajan',
    name: 'عبدالله البعيجان',
    reciter: 'عبدالله البعيجان',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/buajan',
    category: 'كبار القراء',
    description: 'بث مستمر — عبدالله البعيجان'
  },
  {
    id: 'q-a_binhameed',
    name: 'أحمد طالب بن حميد',
    reciter: 'أحمد طالب بن حميد',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/a_binhameed',
    category: 'كبار القراء',
    description: 'بث مستمر — أحمد طالب بن حميد'
  },
  {
    id: 'q-gareeb-quran',
    name: 'تفسير غريب القرآن',
    reciter: 'تفسير غريب القرآن',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/gareeb-quran',
    category: 'التفسير والعلوم',
    description: 'بث مستمر — تفسير غريب القرآن'
  },
  {
    id: 'q-bader',
    name: 'بدر التركي',
    reciter: 'بدر التركي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/bader',
    category: 'كبار القراء',
    description: 'بث مستمر — بدر التركي'
  },
  {
    id: 'q-hazza',
    name: 'هزاع البلوشي',
    reciter: 'هزاع البلوشي',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/hazza',
    category: 'كبار القراء',
    description: 'بث مستمر — هزاع البلوشي'
  },
  {
    id: 'q-0tpy1h0kxtzuv',
    name: 'إذاعة القرآن الكريم - السعودية',
    reciter: 'إذاعة القرآن الكريم - السعودية',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://stream.radiojar.com/0tpy1h0kxtzuv',
    category: 'كبار القراء',
    description: 'بث مستمر — إذاعة القرآن الكريم - السعودية'
  },
  {
    id: 'q-shmaeel',
    name: 'الشمائل المحمدية',
    reciter: 'الشمائل المحمدية',
    country: 'إذاعة قرآنية',
    countryCode: 'QR',
    countryFlag: '📻',
    url: 'https://backup.qurango.net/radio/shmaeel',
    category: 'كبار القراء',
    description: 'بث مستمر — الشمائل المحمدية'
  }
];
